export interface CountryInfo {
  currency: string;
}

export const countryInfo: Record<string, CountryInfo> = {
  PL: { currency: 'PLN' },
  US: { currency: 'USD' },
  GB: { currency: 'GBP' },
  DE: { currency: 'EUR' },
  FR: { currency: 'EUR' },
  ES: { currency: 'EUR' },
  IT: { currency: 'EUR' },
  NL: { currency: 'EUR' },
  BE: { currency: 'EUR' },
  PT: { currency: 'EUR' },
  IE: { currency: 'EUR' },
  AT: { currency: 'EUR' },
  CH: { currency: 'EUR' },
  SE: { currency: 'EUR' },
  NO: { currency: 'EUR' },
  DK: { currency: 'EUR' },
  FI: { currency: 'EUR' },
  AU: { currency: 'AUD' },
  NZ: { currency: 'NZD' },
  CA: { currency: 'CAD' },
  MX: { currency: 'MXN' },
  BR: { currency: 'BRL' },
  AR: { currency: 'ARS' },
  CL: { currency: 'CLP' },
  CO: { currency: 'COP' },
  PE: { currency: 'PEN' },
  VE: { currency: 'VES' },
  ZA: { currency: 'ZAR' },
  EG: { currency: 'EGP' },
  NG: { currency: 'NGN' },
  KE: { currency: 'KES' },
  SA: { currency: 'SAR' },
  AE: { currency: 'AED' },
  IL: { currency: 'ILS' },
  TR: { currency: 'TRY' },
  RU: { currency: 'RUB' },
  IN: { currency: 'INR' },
  CN: { currency: 'CNY' },
  JP: { currency: 'JPY' },
  KR: { currency: 'KRW' },
  SG: { currency: 'SGD' },
  MY: { currency: 'MYR' },
  ID: { currency: 'IDR' },
  TH: { currency: 'THB' },
  VN: { currency: 'VND' },
  PH: { currency: 'PHP' },
  // Additional EU countries
  BG: { currency: 'EUR' },
  HR: { currency: 'EUR' },
  CY: { currency: 'EUR' },
  CZ: { currency: 'EUR' },
  EE: { currency: 'EUR' },
  GR: { currency: 'EUR' },
  HU: { currency: 'EUR' },
  LV: { currency: 'EUR' },
  LT: { currency: 'EUR' },
  LU: { currency: 'EUR' },
  MT: { currency: 'EUR' },
  RO: { currency: 'EUR' },
  SK: { currency: 'EUR' },
  SI: { currency: 'EUR' },
}; 